/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import {PartNumberChangeSolutionMaterialDetailModel} from '../../models/part-number-change-solution-material-detail.model';
import {PartNumberChangeSolveMaterialCommandModel} from '../../../api/ms-partnumberchanges/contracts/part-number-change-solve-material-command.model';
import {PartNumberChangesAiSolutionState} from '../../part-number-changes-ai-solution/part-number-changes-ai-solution.state';

@Injectable({
    providedIn: 'root'
})
export class PncSolutionUtilService {

    convertSolutionMaterial(solution: PartNumberChangeSolutionMaterialDetailModel
            | PartNumberChangesAiSolutionState): PartNumberChangeSolveMaterialCommandModel {
        let finalMaterial: PartNumberChangeSolveMaterialCommandModel = null;
        if (solution != null) {
            finalMaterial = {
                number: (typeof solution.material === 'string') ? undefined : solution.material?.number,
                quantity: solution.quantity?.length > 0 ? `${solution?.quantity}` : null
            };
        }
        return finalMaterial;
    }
}
